import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const RecordingStopIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00031C14.1663 4.59466 11.4059 1.83349 8.00032 1.83331C4.59456 1.83331 1.83333 4.59455 1.83333 8.00031C1.8335 11.4059 4.59467 14.1663 8.00032 14.1663C11.4058 14.1661 14.1662 11.4058 14.1663 8.00031ZM15.1663 8.00031C15.1662 11.9581 11.9581 15.1661 8.00032 15.1663C4.04239 15.1663 0.833504 11.9582 0.833328 8.00031C0.833328 4.04226 4.04228 0.833313 8.00032 0.833313C11.9582 0.833489 15.1663 4.04237 15.1663 8.00031Z"
      fill="currentColor"
    />
    <path
      d="M10.5 9.33301C10.5 9.97734 9.97734 10.5 9.33301 10.5H6.66699C6.02266 10.5 5.5 9.97734 5.5 9.33301V6.66699C5.5 6.02266 6.02266 5.5 6.66699 5.5H9.33301C9.97734 5.5 10.5 6.02266 10.5 6.66699V9.33301Z"
      fill="currentColor"
    />
  </svg>
);
